import React from 'react';
import { AppleIcon, PlayIcon } from 'lucide-react';
const APP_STORE_URL = 'https://apps.apple.com/us/app/intellieats/id6744873855';
const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.Lakh.intelli_eats&pcampaignid=web_share';
type AppStoreLinksProps = {
  /** 'light' sits on a light surface, 'dark' sits on a dark surface. */
  tone?: 'light' | 'dark';
  className?: string;
};
export function AppStoreLinks({
  tone = 'light',
  className = ''
}: AppStoreLinksProps) {
  const base = 'inline-flex items-center gap-2 rounded-full px-5 py-3 text-sm font-bold transition-colors';
  const primary = tone === 'dark' ? `${base} bg-white text-slate-900 hover:bg-slate-100` : `${base} bg-brand-600 text-white hover:bg-brand-700`;
  const secondary = tone === 'dark' ? `${base} border border-white/40 text-white hover:bg-white/10` : `${base} border border-brand-300 bg-white text-brand-700 hover:bg-brand-100`;
  return <div className={`flex flex-wrap gap-3 ${className}`} data-id="element-90" data-mp="2a3zt2m5vtk8">
      <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer" className={primary} data-id="element-91" data-mp="hrvx95xrvid0">
        <AppleIcon className="h-4 w-4" aria-hidden="true" data-id="element-92" data-mp="mpdwg4lzmj7t" />
        Download on the App Store
      </a>
      <a href={GOOGLE_PLAY_URL} target="_blank" rel="noopener noreferrer" className={secondary} data-id="element-93" data-mp="rkt8qs4ck724">
        <PlayIcon className="h-4 w-4" aria-hidden="true" data-id="element-94" data-mp="3uzyzspq3l9r2" />
        Get it on Google Play
      </a>
    </div>;
}